export default class FeedbackEffects {
    static shake(element) {
        if (!element) return;
        element.classList.add("wizz");
        element.addEventListener("animationend", () => element.classList.remove("wizz"), { once: true });
    }

    static confetti(element) {
        if (!element) return;
        const rect = element.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const colors = ["#1dd710", "#ffe300", "#a855f7", "#402DB3", "#F05050"];

        for (let i = 0; i < 20; i++) {
            const dot = document.createElement("div");
            dot.className = "confetti-particle";
            dot.style.left = cx + "px";
            dot.style.top = cy + "px";
            dot.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
            document.body.appendChild(dot);

            const angle = (Math.random() * Math.PI * 2);
            const distance = 40 + Math.random() * 80;
            const dx = Math.cos(angle) * distance;
            const dy = Math.sin(angle) * distance - 30;
            const scale = 0.5 + Math.random() * 0.8;

            dot.animate([
                { transform: "translate(0, 0) scale(1)", opacity: 1 },
                { transform: `translate(${dx}px, ${dy}px) scale(${scale})`, opacity: 0 }
            ], { duration: 500 + Math.random() * 300, easing: "cubic-bezier(0, 0.5, 0.5, 1)" })
            .onfinish = () => dot.remove();
        }
    }
}
